import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { mergeInitialValues } from '@utils/formik';

import { selectHealthQuoteBuyRoute } from '../selector';
import { useFormValues } from '../HealthQuoteBuyCustomForm';

export const useInitialValues = () => {
  const { healthQuote } = useSelector(selectHealthQuoteBuyRoute);
  const values = useFormValues();

  return useMemo(() => {
    if (!healthQuote) return null;
    const { members } = healthQuote;
    return mergeInitialValues(values, { ...healthQuote, ...members });
  }, [healthQuote]);
};
